import React from "react";

const WEEKDAYS = [
    { value: 0, label: "Sun" },
    { value: 1, label: "Mon" },
    { value: 2, label: "Tue" },
    { value: 3, label: "Wed" },
    { value: 4, label: "Thu" },
    { value: 5, label: "Fri" },
    { value: 6, label: "Sat" },
];

const RepeatAdvancedFields = ({
    repetition,
    repeatInterval = 1,
    repeatDays = [],
    repeatEndType = "never",
    repeatEndDate = "",
    onChange,
    disabled = false,
}) => {
    if (!repetition || repetition === "none") return null;

    const showAdvanced = repetition === "custom" || repetition === "weekly" || repetition === "weekdays";

    const toggleDay = (day) => {
        const set = new Set(repeatDays);
        if (set.has(day)) set.delete(day);
        else set.add(day);
        onChange?.({ repeat_days: Array.from(set).sort((a, b) => a - b) });
    };

    return (
        <div className="mt-3 space-y-3 rounded-lg border border-line bg-surface-2/50 p-3">
            {(repetition === "custom" || showAdvanced) && (
                <div className="flex flex-wrap items-center gap-2">
                    <span className="text-xs text-ink-muted">Every</span>
                    <input
                        type="number"
                        min={1}
                        max={365}
                        value={repeatInterval}
                        disabled={disabled}
                        onChange={(e) =>
                            onChange?.({ repeat_interval: Math.max(1, Number(e.target.value) || 1) })
                        }
                        className="w-16 rounded-md border border-line bg-surface px-2 py-1 text-xs text-ink outline-none focus:border-primary"
                    />
                    <select
                        value={repetition === "custom" ? "day" : repetition === "weekly" ? "week" : "day"}
                        disabled={disabled}
                        onChange={(e) => onChange?.({ repeat_unit: e.target.value })}
                        className="rounded-md border border-line bg-surface px-2 py-1 text-xs text-ink outline-none focus:border-primary"
                    >
                        <option value="hour">hour(s)</option>
                        <option value="day">day(s)</option>
                        <option value="week">week(s)</option>
                        <option value="month">month(s)</option>
                        <option value="year">year(s)</option>
                    </select>
                </div>
            )}

            {(repetition === "weekly" || repetition === "weekdays" || repetition === "custom") && (
                <div>
                    <p className="mb-1.5 text-xs text-ink-muted">Repeat on</p>
                    <div className="flex flex-wrap gap-1">
                        {WEEKDAYS.map((d) => {
                            const active = repeatDays.includes(d.value);
                            return (
                                <button
                                    key={d.value}
                                    type="button"
                                    disabled={disabled}
                                    onClick={() => toggleDay(d.value)}
                                    className={`rounded-full border px-2 py-0.5 text-[11px] font-medium transition ${
                                        active
                                            ? "border-primary bg-primary-soft text-primary"
                                            : "border-line text-ink-secondary hover:bg-surface-3"
                                    }`}
                                >
                                    {d.label}
                                </button>
                            );
                        })}
                    </div>
                </div>
            )}

            <div className="flex flex-wrap items-center gap-2">
                <span className="text-xs text-ink-muted">Ends</span>
                <select
                    value={repeatEndType}
                    disabled={disabled}
                    onChange={(e) => onChange?.({ repeat_end_type: e.target.value })}
                    className="rounded-md border border-line bg-surface px-2 py-1 text-xs text-ink outline-none focus:border-primary"
                >
                    <option value="never">Never</option>
                    <option value="until_date">On date</option>
                </select>
                {repeatEndType === "until_date" && (
                    <input
                        type="date"
                        value={repeatEndDate}
                        disabled={disabled}
                        onChange={(e) => onChange?.({ repeat_end_date: e.target.value })}
                        className="rounded-md border border-line bg-surface px-2 py-1 text-xs text-ink outline-none focus:border-primary [color-scheme:dark]"
                    />
                )}
            </div>
        </div>
    );
};

export default RepeatAdvancedFields;
